/**
 * 自定义navigate 基于role.gameCode来进行路由跳转
 */
import { useNavigate } from 'react-router-dom'
import { useStoreState } from '@/store'
import { To } from '@remix-run/router'
import { NavigateOptions } from 'react-router/dist/lib/context'

export const useNav = () => {
  const navigate = useNavigate()
  const { role }: any = useStoreState()

  const nav = (to: To, options?: NavigateOptions) => navigate(genLink(to), options)

  const genLink = (to: To) => role.gameCode ? `/${role.gameCode}${to}` : to

  return { nav, genLink }
}
